import { supabase } from '../lib/supabase';

export const messageService = {
  // Get or create conversation between customer and supplier
  async getOrCreateConversation(customerId, supplierId) {
    try {
      // Check if conversation exists
      const { data: existing, error: fetchError } = await supabase?.from('conversations')?.select('*')?.eq('customer_id', customerId)?.eq('supplier_id', supplierId)?.single();

      if (existing) return { data: existing, error: null };

      // Create new conversation
      const { data, error } = await supabase?.from('conversations')?.insert({
          customer_id: customerId,
          supplier_id: supplierId
        })?.select()?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Get messages for a conversation
  async getMessages(conversationId) {
    try {
      const { data, error } = await supabase?.from('messages')?.select(`
          *,
          sender:user_profiles!messages_sender_id_fkey(
            id,
            full_name,
            avatar_url,
            role
          )
        `)?.eq('conversation_id', conversationId)?.order('created_at', { ascending: true });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Send a message
  async sendMessage(conversationId, senderId, messageText, messageType = 'text', imageUrl = null, imageAlt = null) {
    try {
      const { data, error } = await supabase?.from('messages')?.insert({
          conversation_id: conversationId,
          sender_id: senderId,
          message_text: messageText,
          message_type: messageType,
          image_url: imageUrl,
          image_alt: imageAlt
        })?.select(`
          *,
          sender:user_profiles!messages_sender_id_fkey(
            id,
            full_name,
            avatar_url,
            role
          )
        `)?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Subscribe to new messages in a conversation
  subscribeToMessages(conversationId, callback) {
    const channel = supabase?.channel(`messages:${conversationId}`)?.on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages',
          filter: `conversation_id=eq.${conversationId}`
        },
        async (payload) => {
          // Fetch complete message with sender info
          const { data } = await supabase?.from('messages')?.select(`
              *,
              sender:user_profiles!messages_sender_id_fkey(
                id,
                full_name,
                avatar_url,
                role
              )
            `)?.eq('id', payload?.new?.id)?.single();

          if (data) callback(data);
        }
      )?.subscribe();

    return channel;
  },

  // Mark messages as read
  async markAsRead(conversationId, userId) {
    try {
      const { error } = await supabase?.from('messages')?.update({ is_read: true })?.eq('conversation_id', conversationId)?.neq('sender_id', userId);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      return { error };
    }
  },

  // Get unread message count
  async getUnreadCount(userId) {
    try {
      const { data, error } = await supabase?.from('messages')?.select('id', { count: 'exact', head: true })?.eq('is_read', false)?.neq('sender_id', userId);

      if (error) throw error;
      return { count: data || 0, error: null };
    } catch (error) {
      return { count: 0, error };
    }
  }
};